var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1006(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M444.097,460.535c-5.675,28.642 -8.983,52.502 -8.983,82.714c0,176.224 103.353,331.663 230.654,397.399c-177.379,0 -331.336,-87.732 -407.359,-215.885l-2.737,3.537c-62.377,24.957 -124.134,73.896 -123.228,194.603c1.249,166.29 180.743,180.215 180.743,180.215l594.22,0.229c-0,0 207.57,-23.943 210.601,-245.832c3.189,-233.476 -223.121,-248.051 -229.223,-259.718c-45.324,-86.657 -76.138,-203.47 -274.895,-204.707c-75.744,-0.472 -128.603,26.471 -169.793,67.445Z",
    style: {
      fill: "#e5e5e5"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.106,714.363l4.601,-3.471c-68.099,27.246 -136.001,80.371 -135.012,212.151c1.372,182.808 198.042,198.768 198.042,198.768c0.48,0.038 0.961,0.056 1.442,0.057l594.22,0.229c0.721,0 1.441,-0.041 2.156,-0.123c0,-0 223.938,-25.347 227.201,-264.203c3.054,-223.575 -189.854,-260.098 -234.105,-273.98c-27.204,-53.141 -51.229,-115.423 -107.92,-158.053c-39.936,-30.031 -95.916,-50.87 -180.724,-51.398c-81.72,-0.508 -138.695,28.696 -183.133,72.902c-2.645,2.63 -4.444,5.99 -5.169,9.648c-5.925,29.903 -9.341,54.817 -9.341,86.359c0,153.966 75.932,292.566 178.643,373.748c-139.852,-19.562 -257.827,-96.199 -320.472,-201.8l-16.126,28.316l-14.303,-29.15Zm8.079,35.8c82.043,124.687 236.466,209.235 413.583,209.235c8.65,0 16.178,-5.917 18.22,-14.323c2.042,-8.406 -1.931,-17.118 -9.617,-21.087c-121.898,-62.946 -220.507,-211.995 -220.507,-380.739c0,-26.856 2.767,-48.457 7.517,-73.369l0.002,-0.003c37.348,-35.504 85.086,-58.456 152.39,-58.038c74.198,0.462 123.481,17.597 158.421,43.871c53.721,40.397 73.962,101.039 99.977,150.777c1.435,2.745 4.152,6.408 9.563,9.289c4.249,2.262 14.377,5.179 28.455,9.145c56.642,15.96 191.442,58.78 189.071,232.338c-2.685,196.509 -178.616,225.303 -193.061,227.336c-0.009,0.002 -592.219,-0.227 -592.219,-0.227c-11.426,-1.045 -161.705,-17.512 -162.786,-161.606c-0.772,-102.88 48.151,-148.626 100.991,-172.599Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M665.768,145.849c-252.707,-0 -457.873,178.069 -457.873,397.4c-0,219.33 205.166,397.399 457.873,397.399c-127.301,-65.736 -230.654,-221.175 -230.654,-397.399c0,-176.225 103.353,-331.664 230.654,-397.4Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "37.5px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1006);
export default __webpack_public_path__ + "static/media/1006.265734f1fc644d14f8f797a793b44b93.svg";
export { ForwardRef as ReactComponent };